export const apiUrl = () => process.env.NODE_ENV !== "development" ? "/api/" :
    `https://${window.location.hostname}:7020/api/`;
export const signalRUrl = () => process.env.NODE_ENV !== "development" ? "/hubs/" :
    `https://${window.location.hostname}:7020/hubs/`;
